import { createContext } from 'react';
import { BreadcrumbPartType } from '../types';

type State = {
  breadcrumbs?: ReadonlyArray<BreadcrumbPartType>;
  loading: boolean;
};

const BreadcrumbContext = createContext<State>({
  loading: false,
});
BreadcrumbContext.displayName = 'BreadcrumbContext';

export { BreadcrumbContext };
